// Browser-side Supabase client. Present only when VITE_SUPABASE_URL /
// VITE_SUPABASE_ANON_KEY are configured (local dev may run without auth —
// see RequireAuth for the dev-only fallback; this is dead code in prod
// when the env vars are always set).

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env['VITE_SUPABASE_URL'] as string | undefined;
const anonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'] as string | undefined;

export function isAuthConfigured(): boolean {
  return Boolean(url && anonKey);
}

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (!isAuthConfigured()) return null;
  if (!client) {
    client = createClient(url!, anonKey!, {
      auth: {
        persistSession: true,
        detectSessionInUrl: true, // /verify magic-link & confirm links
        autoRefreshToken: true,
      },
    });
  }
  return client;
}
